export default class Slider {
    constructor(params) {
        const { slider } = params;

        if (!slider) {
            throw Error(
                'Please instantiate with a valid slider element from the DOM.'
            );
        }

        this.adjustTrailWidth = this.adjustTrailWidth.bind(this);

        this.slider = slider;
        this.sliderValue = this.slider.value;
        this.wrapper = this.slider.parentNode;
        this.trail = this.wrapper.querySelector('.jdg-slider-trail');

        this.trail.style.width = `${this.sliderValue}%`;

        this.slider.addEventListener('input', () => this.adjustTrailWidth());
        window.addEventListener('resize', () => this.adjustTrailWidth());
        this.sliderObserver = new ResizeObserver(() => this.adjustTrailWidth());

        this.sliderObserver.observe(this.slider);
    }

    adjustTrailWidth(event) {
        const sliderMax = this.slider.getAttribute('max');
        const sliderValue = event ? event.target.value : this.slider.value;
        const denominator = sliderMax ?? 100;

        const fivePercent = 0.05 * denominator;
        const eightyFivePercent = 0.85 * denominator;

        let positionOffset = 1;

        if (sliderValue < fivePercent) {
            positionOffset = 12;
        }
        if (sliderValue > eightyFivePercent) {
            positionOffset = -12;
        }

        const percentage = sliderValue / denominator;

        this.sliderValue = sliderValue;
        this.trail.style.width = `calc(${Math.ceil(
            this.slider.clientWidth * percentage
        )}px + ${positionOffset}px)`;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.jdg-slider');

    if (!sliders) {
        return;
    }

    sliders.forEach(slider => new Slider({ slider }));
});
